import {
  B_05,
  BANNER_DEFAULTS,
  hideB05Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B05_PLASMIC_PROPS = {
  b05Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_05].heading,
    description: "Main heading (B05 only)",
    hidden: hideB05Props,
  },
  b05Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_05].description,
    description: "Description text (B05 only)",
    hidden: hideB05Props,
  },
  b05BulletPoints: {
    type: "array",
    defaultValue: BANNER_DEFAULTS[B_05].bulletPoints,
    description: "Bullet points list (B05 only)",
    hidden: hideB05Props,
    itemType: {
      type: "object",
      fields: {
        text: { type: "string" },
        image: { type: "imageUrl" },
        imageAlt: { type: "string" },
      },
    },
  },
  b05PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_05].primaryButtonText,
    description: "Primary button text (B05 only)",
    hidden: hideB05Props,
  },
  b05PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (B05 only)",
    hidden: hideB05Props,
  },
  b05PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (B05 only)",
    hidden: hideB05Props,
  },
  b05PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB05Props(props) ||
      (props.b05PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b05PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b05PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB05Props(props) ||
      (props.b05PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b05PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b05SecondaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_05].secondaryButtonText,
    description: "Secondary button text (B05 only)",
    hidden: hideB05Props,
  },
  b05SecondaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Secondary button link type (B05 only)",
    hidden: hideB05Props,
  },
  b05SecondaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open secondary button in new tab (B05 only)",
    hidden: hideB05Props,
  },
  b05SecondaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB05Props(props) ||
      (props.b05SecondaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b05SecondaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b05SecondaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB05Props(props) ||
      (props.b05SecondaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b05SecondaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b05MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_05].mobileImg,
    description: "Mobile/tablet background image (B05 only)",
    hidden: hideB05Props,
  },
  b05DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_05].desktopImg,
    description: "Desktop background image (B05 only)",
    hidden: hideB05Props,
  },
  b05ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_05].imageAlt,
    description: "Image alt text (B05 only)",
    hidden: hideB05Props,
  },
  b05OverlayOpacity: {
    type: "number",
    defaultValue: BANNER_DEFAULTS[B_05].overlayOpacity,
    description: "Overlay opacity (0-1) (B05 only)",
    hidden: hideB05Props,
  },
};
